module.exports = __webpack_public_path__ + "assets/img/29_296_big.6be9df9a.jpg";